export default [

    {
        path: '',
        name: 'logistica',
        redirect: { name: 'logistica-home' },
    },

    {
        path: 'home',
        name: 'logistica-home',
        component: () => import('@/aplicacao/modulos/logistica/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_LOGISTICA' },
    },

    {
        path: 'correcoes-solicitacoes',
        name: 'logistica-correcoes-solicitacoes',
        component: () => import('@/aplicacao/modulos/logistica/CorrecoesSolicitacoes'),
        meta: { autenticacao: true, permissao: 'ROLE_LOGISTICA_CORRECOES_SOLICITACOES' },
    },

    {
        path: 'correcoes-clientes',
        name: 'logistica-correcoes-clientes',
        component: () => import('@/aplicacao/modulos/logistica/CorrecoesClientes'),
        meta: { autenticacao: true, permissao: 'ROLE_LOGISTICA_CORRECOES_CLIENTES' },
    },

    {
        path: 'impressoes',
        name: 'logistica-impressoes',
        component: () => import('@/aplicacao/modulos/logistica/Impressoes'),
        meta: { autenticacao: true, permissao: 'ROLE_LOGISTICA_IMPRESSOES' },
    },

]
